import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import FormControlLabel from "@mui/material/FormControlLabel";
import PrimaryCheckbox from "../../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function LoadBoardColumnsItem({ item, handleActive }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.columnName });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes}>
      <FormControlLabel
        control={
          <Box>
            <PrimaryCheckbox
              checked={item.isChecked}
              handleChange={(ev) => handleActive(item.title, ev.target.checked)}
            />
          </Box>
        }
        label={
          <Box sx={{ display: "flex", alignItems: "center" }} >
            <DragIndicatorIcon sx={{ color: "black_opacity.70" }} {...listeners} />
            <Typography variant="body1" color="black_opacity.100">
              {item.title}
            </Typography>
          </Box>
        }
      />
    </Box>
  );
}

LoadBoardColumnsItem.propTypes = {
  item: PropTypes.object.isRequired,
  handleActive: PropTypes.func.isRequired
};